export const LANGUAGES = [{
  key: 'EN',
  label: 'en_uk'
}, {
  key: 'US',
  label: 'en_us'
}, {
  key: 'FR',
  label: 'fr'
}, {
  key: 'IT',
  label: 'it'
}, {
  key: 'DE',
  label: 'de'
}, {
  key: 'PT',
  label: 'pt'
}, {
  key: 'BR',
  label: 'pt_br'
}, {
  key: 'RU',
  label: 'ru'
}, {
  key: 'DK',
  label: 'da'
}];
export function getPriorityTranslation(obj, key, language) {
  const currentKey = `${key}${language.toUpperCase()}`;
  return obj[currentKey] || obj[`${key}EN`] || obj[`${key}US`] || obj[`${key}ES`] || obj[`${key}IT`] || obj[`${key}FR`] || obj[`${key}PT`] || obj[`${key}DU`] || obj[`${key}DK`] || obj[`${key}RU`];
}
export function swapItems(items, firstIndex, secondIndex) {
  const results = items.slice();
  const movingItem = results[firstIndex];
  results.splice(firstIndex, 1);
  results.splice(secondIndex, 0, movingItem);
  return results;
}
export function downloadURI(uri, fileName) {
  const a = document.createElement('a');
  a.style.display = 'none';
  document.body.appendChild(a);
  a.href = uri;
  a.setAttribute('download', fileName);
  a.click();
  document.body.removeChild(a);
}
export function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
export function debounce(callback, wait, immediate) {
  if (immediate === void 0) {
    immediate = false;
  }
  let timeout = null;
  return function () {
    const callNow = immediate && !timeout;
    const next = () => callback.apply(this, arguments);
    clearTimeout(timeout);
    timeout = setTimeout(next, wait);
    if (callNow) {
      return next();
    } else {
      return Promise.resolve();
    }
  };
}
export function generateTmpId() {
  return Math.ceil(Date.now() + Math.random());
}